module.exports = __webpack_public_path__ + "static/media/anne-laure-conversation.fb9818ce.png";